export const headers: { [key: string]: string } = {
  "Content-Type": "application/json",
}

const HUMAN_ACCESS_TOKEN = document.body.getAttribute('data-token');
if (HUMAN_ACCESS_TOKEN) {
  document.body.removeAttribute('data-token');
  if (HUMAN_ACCESS_TOKEN !== "%HUMAN_ACCESS_TOKEN%") {
    headers["x-px-access-token"] = HUMAN_ACCESS_TOKEN;
  }
}